import {
  attentionQueueResponseSchema,
  homeAggregatesSchema,
  type AttentionQueueResponse,
  type HomeAggregates,
} from '@console/types'
import { apiGet } from '../api.js'

export async function fetchHomeAggregates(): Promise<HomeAggregates> {
  return apiGet('/home/aggregates', homeAggregatesSchema)
}

export async function fetchAttentionQueue(limit = 6): Promise<AttentionQueueResponse> {
  return apiGet(`/home/attention-queue?limit=${String(limit)}`, attentionQueueResponseSchema)
}
